import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';

export interface LegalOrderedListProps {
  readonly spacing?: 'single' | 'double';
  readonly indent?: 'single' | 'double';
  readonly children: ReactNode;
}

const LegalOrderedList = ({
  spacing = 'single',
  indent = 'single',
  children,
}: LegalOrderedListProps): JSX.Element => {
  return (
    <ol
      className={cx({
        '[&>li]:mb-4': spacing === 'double',
        'ml-4': indent === 'single',
        'ml-12': indent === 'double',
      })}
    >
      {children}
    </ol>
  );
};

export default LegalOrderedList;
